import { getLocalTimezone } from './helpers';

export function formatDateShort(dateValue: number | string | Date, onlyDate = false, includeYear = false) {
    const date = new Date(dateValue);
    const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
    if (!onlyDate) {
        options.hour = 'numeric';
        options.minute = 'numeric';
    }
    if (date.getFullYear() !== new Date().getFullYear() || includeYear) {
        options.year = 'numeric';
    }
    return date.toLocaleString('en-US', options);
}

export function formatAsRelativeTime(timestamp: number, onlyDate = false, includeYear = false): string {
    const timestampMs = timestamp * 1000; // Convert Unix timestamp to milliseconds
    const diffInSeconds = Math.floor((Date.now() - timestampMs) / 1000);

    if (diffInSeconds < 5) return 'Just now';
    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;

    return formatDateShort(timestampMs, onlyDate, includeYear);
}
export function getTimezoneOffset(timeZone: string = 'UTC') {
    const now = new Date();
    const tzString = now.toLocaleString('en-US', { timeZone });
    const localString = now.toLocaleString('en-US');
    const diff = (Date.parse(localString) - Date.parse(tzString)) / 3600000;
    const offset = diff + now.getTimezoneOffset() / 60;
    return -offset;
}

export function isDateInPast(timeStamp: number, timeZone = null) {
    // Default to local timezone
    const timeZoneUse = timeZone || getLocalTimezone();
    // offset current time to GMT 0 + offset to new timezone
    const timeZoneOffsetHours = -getTimezoneOffset() + getTimezoneOffset(timeZoneUse);

    // Current time offset
    const nowAdjusted = new Date(new Date().getTime() + timeZoneOffsetHours * 60000 * 60);

    // new Date(date), will create at UTC+0 then shift to our timezone so we need to offset back to get to midnight
    const checkDateAdjusted = new Date(new Date(timeStamp).getTime() - getTimezoneOffset() * 60000 * 60);

    return checkDateAdjusted < nowAdjusted;
}

export function withTimezone() {
    return { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone };
}

/**
 * Get a formatted date string X days from now
 * Format: "Jan 6" or "Jan 6, 2026" if different year
 */
export function getDateXDaysFromNow(days: number): string {
    const date = new Date();
    date.setDate(date.getDate() + days);

    const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
    if (date.getFullYear() !== new Date().getFullYear()) {
        options.year = 'numeric';
    }

    return date.toLocaleDateString('en-US', options);
}
